<div>
  <div mat-dialog-title>
    Kunde anlegen
  </div>
  <div mat-dialog-content>
    <form [formGroup]="customerForm">
      <mat-form-field class="w-full">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Name" formControlName="name">
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>HubSpot Token</mat-label>
        <input matInput placeholder="HubSpot Token" formControlName="hubspotToken">
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Beschreibung</mat-label>
        <input matInput placeholder="Beschreibung" formControlName="description">
      </mat-form-field>
      <mat-checkbox formControlName="active">Aktiv</mat-checkbox>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-button color="primary" (click)="onOk()">{{'ok' | translate}}</button>
    <button mat-button color="warn" (click)="onCancel()">{{'cancel' | translate}}</button>
  </div>
</div>
